const topics = [
  {
    title: "Force",
    slug: "force",
    standardNumber: "3.2",
    description: "Force, Motion, and Energy – Force is a push or pull that can make an object stop, change its speed, or change its direction.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11",
    lyrics: ["(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"(Verse)",
"Force is a push or a pull that will,",
"Make an object stop.",
"Force is a push or a pull that will,",
"Change an object's speed.",
"Force is a push or a pull that will,",
"Change an object's direction.",
"Force is a push or a pull that will,",
"Change an object's direction.",

"(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Motion",
    slug: "motion",
    standardNumber: "3.2",
    description: "Force, Motion, and Energy – Motion happens when an object changes its position, either by moving a short distance or by continuously traveling like a car on the highway.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: ["(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"(Verse)",
"Use a car as an example, and the car is parked at the curb.",
"Now, you move the car up 10 feet, then a motion has occurred.",
"Now, if you take the same parked car and put it on the highway,",
"Then start coasting.",
"Its position is constantly changing.",
"Then, it's in motion, then it's in motion.",

"(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Work Easy",
    slug: "workeasy",
    standardNumber: "3.2",
    description: "Force, Motion, and Energy – Simple machines like levers, inclined planes, pulleys, wedges, and more make work easier by helping lift, move, or separate objects.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fworkeasy2025video.mp4?alt=media&token=4c21b5b4-4f2e-4c24-bd5b-b45acdf8c77c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fworkeasy2025song.mp3?alt=media&token=e238bb66-d9af-4a5c-8638-e102ac4c98ab",
    lyrics: ["(Chorus)",
"The reason we use simple machines is to make work easy.",
"The reason we use simple machines is to make work easy.",
"The reason we use simple machines is to make work easy.",

"(Verse)",
"We use simple machines to help lift heavy weight,",
"Like a lever, like a seesaw.",
"We use simple machines to help lift heavy weight,",
"Like a lever, like a seesaw.",

"We use simple machines to help move heavy objects,",
"Like an inclined plane, ramp, like an inclined plane, ramp.",
"We use simple machines to help move heavy objects,",
"Like a pulley, crane, like a pulley, crane.",

"We use simple machines to help move things apart,",
"Like a wedge, spatula, like a wedge, spatula.",
"We use simple machines to help move things apart,",
"Like a wedge, crowbar, like a wedge, crowbar.",

"(Chorus)",
"The reason we use simple machines is to make work easy.",
"The reason we use simple machines is to make work easy.",
"The reason we use simple machines is to make work easy.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Simple Machines",
    slug: "simplemachines",
    standardNumber: "3.2",
    description: "Force, Motion, and Energy – Simple machines such as levers, pulleys, wheels and axles, inclined planes, wedges, and screws make lifting, moving, and fastening tasks easier.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsimplemachines2025song.mp3?alt=media&token=afc70153-fff0-48f6-af21-d5abb350f6b7",
    lyrics: ["(chorus)",
"Push it, pull it, lift it high,",
"simple machines help you try.",
"Turn it, roll it, make it go.",
"They make work easier, don’t you know?" ,
"(verse)",
"Simple machines are things like the lever, the pulley,",
"helping us lift and pull heavy things more fully.",
"Simple machines are things like the wheel and axle,",
"rolling loads with ease, makes travel less a hassle.",
"Simple machines are things like the incline plane, the wedge.",
"Ramps make lifting easier, wedges split the edge.",
"And don’t forget the screw, twisting tight and strong.",
"Simple machines, simple machines, helping all day long.",
"(chorus)",
"Push it, pull it, lift it high,",
"simple machines help you try.",
"Turn it, roll it, make it go.",
"They make work easier, don’t you know?",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragAndDrop",
    titleImage: "",
  },
  {
    title: "Mixtures",
    slug: "mixtures",
    standardNumber: "3.3",
    description: "Matter – Mixtures are made when different substances combine, like salt water, sand and rocks, trail mix, or smoothies, and some can be separated while others stay blended.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmixtures2025song.mp3?alt=media&token=811b0f52-2c13-4ae6-8f78-c3afcdedbebd",
    lyrics: ["(Chorus)",
"Mixtures, mixtures, they’re all around,",
"Different things together, can you hear the sound?",
"Some can be separated, others stay combined,",
"Let’s learn about mixtures of every kind!",
" (Verse)",
"Salt and water make a mixture, see,",
"The salt dissolves, but it’s still salty!",
"Sand and rocks, they stay apart,",
"You can pick them out, that’s pretty smart!",
"Trail mix is a mixture, so much fun,",
"pick out the peanuts, raisins, one by one.",
"A smoothie’s a mixture, blended so fine,",
"All the fruits mix, and that’s just fine!",
" (Chorus)",
"Mixtures, mixtures, they’re all around,",
"Different things together, can you hear the sound?",
"Some can be separated, others stay combined,",
"Let’s learn about mixtures of every kind!",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Hot Water Dissolves Faster",
    slug: "hotwaterdissolvesfaster",
    standardNumber: "3.3",
    description: "Matter – Sugar dissolves faster in hot water because heated molecules move more quickly and collide with the sugar more often.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhotwaterdissolvesfaster2025song.mp3?alt=media&token=d061262d-e2d3-41ff-b7cc-177c76389a3b",
    lyrics: ["(chorus)",
"When you put sugar in hot water it dissolves faster,",
"it dissolves faster, it dissolves faster.",
"When you put sugar in hot water it dissolves faster,",
"it dissolves faster, it dissolves faster,",
"than it does in cold water,",
"because hot water has more energy,",
"hot water has more energy,",
"hot water has more energy.",

"(verse)",
"When you heat the water, the molecules gain energy.",
"When you heat the water, the molecules gain energy.",
"When the molecules gain energy, they move faster.",
"When the molecules gain energy, they move faster.",
"The faster molecules come into contact with the sugar more often,",
"causing the sugar to dissolve faster, causing the sugar to dissolve faster.",

"(chorus)",
"When you put sugar in hot water it dissolves faster,",
"it dissolves faster, it dissolves faster.",
"When you put sugar in hot water it dissolves faster,",
"it dissolves faster, it dissolves faster,",
"than it does in cold water,",
"because hot water has more energy,",
"hot water has more energy,",
"hot water has more energy.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Adaptation",
    slug: "adaptation",
    standardNumber: "3.4",
    description: "Living Systems and Processes – Adaptation is how plants and animals adjust to their environment by conserving resources, using camouflage or mimicry, and developing features that help them survive in different conditions.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptation2025video.mp4?alt=media&token=38306b56-b3b8-4d35-9d62-460a899023b4",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptation2025song.mp3?alt=media&token=dc122dec-b0b5-4656-82c2-8e1c2297489b",
    lyrics: ["(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"(Verse 1)",
"There are some places on Earth that’s very cold or very hot,",
"And still plants and animals live there, they’ve adapted to being there.",
"Some places on Earth have lots of water or lots of rocks,",
"And still plants and animals live there, they’ve adapted to being there.",
"Let’s take a place that doesn’t have much water.",
"Plants and animals both know how to conserve water, store that water.",
"Let’s take a place with high temperatures.",
"Plants move their leaves to minimize surface area hit by the sun.",
"In a place with high temperatures,",
"They both reduce heat output and animals use the shade to avoid the sun.",

"(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"(Verse 2)",
"Some animals camouflage, change their color or pattern to blend in.",
"Some animals’ mimicry, change their whole look to look like something different.",
"Some plants have needles, to cause pain feelings in animals that touch it.",
"Some plants are poison, to harm an enemy that tries to eat it.",

"(Chorus)",
"What is adaptation? The way plants and animals learn to survive.",
"What is adaptation? How they live in their habitat or environment.",
"We adapt, we adapt,",
"To our habitat, to our habitat.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Adaptive Characteristics",
    slug: "adaptivecharacteristics",
    standardNumber: "3.4",
    description: "Living Systems and Processes – Animals develop adaptive traits like webbed feet for swimming, sharp claws for hunting or digging, and strong beaks or teeth for eating, all of which help them survive in their ecosystems.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadaptivecharacteristics2025video.mp4?alt=media&token=8bef488a-f405-4403-bf1d-b2befa2d032d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadaptivecharacteristics2025song.mp3?alt=media&token=07c0340b-fe8d-4ae7-8c5b-b4355a19bacd",
    lyrics: ["(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"(verse)",
"Some animals have webbed feet just like an otter.",
"They can search for food in the water, it makes them swim better.",
"Some animals have sharp claws, like meat eaters,",
"and they use those claws for killing their prey.",
"Some use them for digging for food or shelter, hay.",
"Some animals have large beaks, it helps some animals eat.",
"Some animals have large teeth, it helps the animals eat.",
"Some animals have large beaks, it helps some animals eat.",

"(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"(verse)",
"Some animals have webbed feet just like an otter.",
"They can search for food in the water, it makes them swim better.",
"Some animals have sharp claws, like meat eaters,",
"and they use those claws for killing their prey.",
"Some use them for digging for food or shelter, hay.",
"Some animals have large beaks, it helps some animals eat.",
"Some animals have large teeth, it helps the animals eat.",
"Some animals have large beaks, it helps some animals eat.",

"(chorus)",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",
"Let’s analyze and describe some adaptive characteristics",
"up in the ecosystem.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Fossils",
    slug: "fossils",
    standardNumber: "3.4",
    description: "Living Systems and Processes – Fossils form when plants or animals are buried and turned to rock over time, preserving evidence of life from the past.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffossils2025song.mp3?alt=media&token=47c4b721-ea40-4b8f-a502-1d6df74ec090",
    lyrics: ["(chorus)",
"Fossils, hello to you,",
"fossils, hello to you,",
"fossils, how do you do?",
"Fossils, tell us the past,",
"fossils, tell us the past,",
"fossils, we won’t know without you.",
"(verse)",
"A fossil comes from long ago,",
"plants or animals we used to know.",
"Buried deep in dirt and sand,",
"turned to rock beneath the land.",
"Pressure builds and keeps it tight,",
"locked away and out of sight.",
"Wind and rain can break the stone,",
"and that’s how fossils are shown.",
"(chorus)",
"Fossils, hello to you,",
"fossils, hello to you,",
"fossils, how do you do?",
"Fossils, tell us the past,",
"fossils, tell us the past,",
"fossils, we won’t know without you.",
"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Ecosystem Levels",
    slug: "ecosystemlevels",
    standardNumber: "3.5",
    description: "Living Systems and Processes – The levels of organization in an ecosystem progress from a single organism to a population, then to a community, and finally to the entire ecosystem of living and nonliving things.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecosystemlevels2025video.mp4?alt=media&token=d28fd355-34df-4108-aa08-aab6454be863",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecosystemlevels2025song.mp3?alt=media&token=936d0836-5ca7-4b69-bb1c-04b8c39d689b",
    lyrics: ["(chorus)",
"There's levels or organization in every ecosystem.",
"There's levels or organization in every ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",

"(verse)",
"Let's start with a single organism and call it level one.",
"When that organism reproduce, and they reproduce, population has begun.",
"Now, organisms interact with different organisms, it's a community.",
"To make it an ecosystem, add the living things with the non-living things.",

"(chorus)",
"There's levels or organization in every ecosystem.",
"There's levels or organization in every ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Food Web",
    slug: "foodweb",
    standardNumber: "3.5",
    description: "Living Systems and Processes – A food web shows the many connected paths of how plants and animals depend on each other for survival, creating a balanced ecosystem.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffoodweb2025video.mp4?alt=media&token=1c7eae0b-5548-486a-8a71-7af001a21cb5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffoodweb2025song.mp3?alt=media&token=d9108a4b-545b-4ce0-ac4f-f96ce831ccd2",
    lyrics: ["(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Verse 1)",
"Trees make acorns, food for bugs and mice.",
"When the mice are here, snakes and owls think it’s nice.",
"Bugs are food for birds, and skunks eat them too.",
"Every animal matters, they all have jobs to do.",
"If one animal goes, the others feel the loss.",
"Like a broken web, it comes at a big cost.",

"(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Verse 2)",
"Plants give food to animals, animals help them grow.",
"If one part disappears, it’s hard for others, you know.",
"Foxes eat the rabbits, rabbits eat the grass.",
"Everything works together so nature can last.",
"The food web is a circle, a balance we must keep.",
"Protecting every animal and the places where they sleep.",

"(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Outro)",
"So let’s take care of nature, the plants, the animals too.",
"The food web keeps them living, and it helps us all too!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragAndDrop",
    titleImage: "",
  },
  {
    title: "Food Chain",
    slug: "foodchain",
    standardNumber: "3.5",
    description: "Living Systems and Processes – A food chain shows the straight path of energy as it moves from producers like plants to consumers such as animals.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffoodchain2025video.mp4?alt=media&token=9b71ff42-697f-4de2-8adf-573beac0d90a",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffoodchain2025song.mp3?alt=media&token=6800dd25-d5a1-43fe-b181-913ce4501b09",
    lyrics: ["(chorus)",
"Grass is eaten by a grasshopper, who is eaten by a frog,",
"who is eaten by a snake, who is eaten by a hawk.",
"That’s how the food chain works.",
"Right down the line that’s how the food chain works.",

"(verse)",
"A food chain explains how food energy goes between living things",
"in an environment, in an environment.",
"Producers are at the bottom of the food chain.",
"Consumers go to the top of the food chain",
"by eating living things in an environment.",

"(chorus)",
"Grass is eaten by a grasshopper, who is eaten by a frog,",
"who is eaten by a snake, who is eaten by a hawk.",
"That’s how the food chain works.",
"Right down the line that’s how the food chain works.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Soil",
    slug: "soil",
    standardNumber: "3.6",
    description: "Earth and Space Systems – Soil is a natural resource made of weathered rock, organic material, air, and water that supports plant growth, recycles nutrients, and provides shelter for many organisms.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoil2025video.mp4?alt=media&token=3bca78d6-bf7e-41d8-aeac-e798bd67dc16",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoil2025song.mp3?alt=media&token=228811c5-3593-4ea7-8753-cd5af3e86ffd",
    lyrics: ["(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"(Verse)",
"Soil is a mixture of organic materials, air, and water,",
"rocks broken down due to weathering,",
"remains of dead plants and animals, everything.",
"Soil covers a lot of Earth’s land.",
"A natural resource that’s important.",
"Soil gives plants the right nutrients,",
"so we can live, so we can live.",

"Microbes in the soil break down and decay,",
"dead organisms every day,",
"and many animals make their homes and shelters,",
"in soil every day.",

"(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Soil Soil What Can you Do?",
    slug: "soilsoilwhatcanyoudo",
    standardNumber: "3.6",
    description: "Earth and Space Systems – Sandy soil drains quickly but doesn’t hold much water, clay soil holds water but limits root growth, and loam is the best mix with nutrients, air, and water balance, making it ideal for healthy plant growth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoilsoilwhatcanyoudo2025video.mp4?alt=media&token=25759a8e-7b7a-4984-b8c1-da68aefef674",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoilsoilwhatcanyoudo2025song.mp3?alt=media&token=91c5d957-f41c-44f2-870a-c0f6eb120d00",
    lyrics: ["(Chorus)",
"Soil, soil, what can you do?",
"Soil, soil, it’s all up to you.",
"Helping plants live, helping plants grow.",
"Soil, soil, it’s all up to you.",

"(Verse 1)",
"Sandy soil is loose and light,",
"Water slips right through because sandy soil don’t hold tight.",
"It doesn’t hold much water, it’s dry and bare,",
"But mix it up, and plants grow there!",
"Clay is heavy, sticky, and slow,",
"It holds the water, it doesn’t let it go.",
"It’s harder for plants to grow in clay because roots need air,",
"But mix it with sand, and plants grow there!",
"Loam is perfect, the best of all,",
"It holds the water and lets roots crawl.",
"With nutrients rich and texture just right,",
"Plants grow strong, reaching new heights!",

"(Chorus)",
"Soil, soil, what can you do?",
"Help the plants grow, it’s up to you!",
"Some hold water, some stay dry,",
"Soil helps the roots reach up to the sky!",

"(Bridge)",
"Each soil is different, each one can bring,",
"Water, air, and nutrients for everything.",
"Soil supports the plants, helps them survive,",
"With the right soil, the plants will thrive!",
"So let’s learn about soil, it’s fun to know,",
"What helps our plants and gardens grow.",
"From sandy to clay, and loam so true,",
"Soil, soil, we depend on you!",

"(Chorus)",
"Soil, soil, what can you do?",
"Help the plants grow, it’s up to you!",
"Some hold water, some stay dry,",
"Soil helps the roots reach up to the sky!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "What do Plants Need",
    slug: "whatdoplantsneed",
    standardNumber: "3.6",
    description: "Earth and Space Systems – Animals need food, water, air, and shelter to survive, with some living on land and others in water, while plants need air, light, water, and soil nutrients, providing food for both people and animals in aquatic or terrestrial environments.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhatdoplantsneed2025video.mp4?alt=media&token=2172b66c-8868-45bf-8a14-dd8f6be2f4ec",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatdoplantsneed2025song.mp3?alt=media&token=95132d97-2377-471a-9d92-9562b9dec2e7",
    lyrics: ["(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 1)",
"Animals need food and water.",
"Animals need food and water.",
"Animals need air and shelter.",
"Animals need air and shelter.",
"Some animals get their oxygen from the air.",
"That makes them terrestrial.",
"Some animals get their oxygen from the water.",
"That makes them aquatic.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 2)",
"Plants need air, light, water, and nutrients from the soil.",
"Plants need air, light, water, and nutrients from the soil.",
"Plants provide food for people.",
"Plants provide food for animals.",
"Plants can be aquatic.",
"Plants can be terrestrial.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Forms of Water",
    slug: "formsofwater",
    standardNumber: "3.7",
    description: "Earth and Space Systems – Reservoirs are lakes or tanks used to collect and store water. Groundwater is the water found beneath Earth’s surface. Rivers are large moving streams, lakes are surrounded by land, bays are partially enclosed by land, and peninsulas are pieces of land surrounded by water on three sides.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fformsofwater2025video.mp4?alt=media&token=8973ee2c-2006-494e-bb3c-f6efcced57c6",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fformsofwater2025song.mp3?alt=media&token=9d23fd03-76b0-48e2-af88-c06d9d9d70ce",
    lyrics: ["(Verse)",
"Reservoir, a lake or tank used to collect water.",
"Reservoir, a lake or tank used to store water.",
"Groundwater, water that is beneath Earth’s surface.",
"Groundwater, water that is beneath Earth’s surface.",
"River, large stream of water that moves.",
"River, large stream of water that moves.",
"Lake, a body of water surrounded by land.",
"Lake, a body of water surrounded by land.",
"Bay, a body of water partially enclosed by land.",
"Bay, a body of water partially enclosed by land.",
"Peninsula, piece of land surrounded by water on three sides.",
"Peninsula, piece of land surrounded by water on three sides.",

"© Smart Board Learning, LLC. All rights reserved."],
    gameType: "dragAndDrop",
    titleImage: "",
  },
  {
    title: "Water Cycle",
    slug: "watercycle",
    standardNumber: "3.7",
    description: "Earth and Space Systems – The water cycle is a continuous circle where water evaporates from Earth’s surface, condenses into clouds, and returns as precipitation to start the cycle again.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwatercycle2025video.mp4?alt=media&token=21f248f9-e435-4a27-b6a7-b457000cb013",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwatercycle2025song.mp3?alt=media&token=5a551a0a-9e64-4c2d-9eb9-24ee6d6c3ca2",
    lyrics: ["(Chorus)",
"It’s a circle, a circle, yup, a circle.",
"The water cycle goes in a circle.",
"Starts with evaporation.",
"Rise to precipitation.",
"Drops back down in the form of snow, sleet, or rain.",

"(Verse)",
"Water is one of the reasons why there’s life on Earth.",
"Water covers 75 percent of the Earth.",
"The equator is an imaginary line,",
"That divides the Earth into two sides.",
"Halfway between the North and South Pole, yeah,",
"The Northern Hemisphere, the Southern Hemisphere.",

"Now the water on Earth goes in a cycle.",
"What a coincidence, it’s called the water cycle.",
"Heat from the sun causes water from the lakes,",
"Oceans and rivers to evaporate.",
"That evaporated water rises till it cools,",
"Then condenses into droplets or ice crystals.",
"Forming a cloud, the cloud lets the water back out,",
"To the ground, rivers, and ponds.",
"In the oceans and into the lakes,",
"And starts all over when the water evaporates.",

"(Chorus)",
"It’s a circle, a circle, yup, a circle.",
"The water cycle goes in a circle.",
"Starts with evaporation.",
"Rise to precipitation.",
"Drops back down in the form of snow, sleet, or rain.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Pollution",
    slug: "pollution",
    standardNumber: "3.8",
    description: "Earth Resources – The student will investigate and understand that natural events and humans influence ecosystems.",
    video: "",
    music: "",
    lyrics: [],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Influence",
    slug: "influence",
    standardNumber: "3.8",
    description: "Earth Resources – Humans can damage the environment through pollution, hunting, and land clearing, or protect it through conservation, preservation, and recycling.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finfluence2025song.mp3?alt=media&token=f6ad4ee0-b548-4918-be36-a1b8eafcabe2",
    lyrics: ["(chorus)",
"We can hurt our environment or",
"We can help our environment",
"We can hurt our environment or",
"We can help our environment",

"(verse)",
"We can hurt our environment,",
"by polluting and strip mining.",
"We can hurt our environment",
"by hunting illegally, and clearing land to build anything",
"We can help our environment,",
"by conservation, protect,",
"and preservation, maintain.",
"We can help our environment",
"by recycling, by recycling.",

"(chorus)",
"We can hurt our environment or",
"We can help our environment",
"We can hurt our environment or",
"We can help our environment",

"(verse)",
"We can hurt our environment,",
"by polluting and strip mining.",
"We can hurt our environment",
"by hunting illegally, and clearing land to build anything",
"We can help our environment,",
"by conservation, protect,",
"and preservation, maintain.",
"We can help our environment",
"by recycling, by recycling.",

"(chorus)",
"We can hurt our environment or",
"We can help our environment",
"We can hurt our environment or",
"We can help our environment",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Natural Resources",
    slug: "naturalresources",
    standardNumber: "3.8",
    description: "Earth Resources – Renewable, nonrenewable, inexhaustible, and recyclable natural resources and their uses.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },

];
export default topics;
